<template>
  <b-row>
    <b-col>
      <b-row>
        <b-col>
          <div v-if="created" class="alert alert-success" role="status">{{ created.name }} {{$t('notifications.created')}}.</div>
          <div v-if="updated" class="alert alert-success" role="status">{{ updated.name }} {{$t('notifications.updated')}}.</div>
          <div v-if="isLoading || deleteLoading" class="alert alert-info" role="status">{{$t('notifications.loading')}}...</div>
          <div v-if="error" class="alert alert-danger" role="alert">
            <span class="fa fa-exclamation-triangle" aria-hidden="true" /> {{ error }}
          </div>
          <div v-if="deleteError" class="alert alert-danger" role="alert">
            <span class="fa fa-exclamation-triangle" aria-hidden="true" /> {{ deleteError }}
          </div>
        </b-col>
      </b-row>
      <b-row>
<!--        <div slot="tagType" slot-scope="props">-->
<!--          <span v-if="props.row.tagType === 1">{{$t('views.excmtag.tagOption.tagTypeOption1')}}</span>-->
<!--          <span v-if="props.row.tagType === 2">{{$t('views.excmtag.tagOption.tagTypeOption2')}}</span>-->
<!--          <span v-if="props.row.tagType === 3">{{$t('views.excmtag.tagOption.tagTypeOption3')}}</span>-->
<!--          <span v-if="props.row.tagType === 4">{{$t('views.excmtag.tagOption.tagTypeOption4')}}</span>-->
<!--        </div>-->
        <b-col>
          <router-link v-if="item" :to="{ name: 'EXCMTagList' }" class="btn btn-default float-right">{{ $t('buttons.backToList') }}</router-link>
          <!--          <button class="btn btn-danger" @click="del">{{ $t('buttons.delete') }}</button>-->
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card>
            <div class="card-body">
              <b-row>
                <b-col>
                  <EXCMTagForm
                    v-if="item"
                    :handle-submit="onSendForm"
                    :handle-update-field="updateField"
                    :values="item"
                    :errors="violations"
                    :initial-values="retrieved" />
                </b-col>
              </b-row>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import EXCMTagForm from './Form.vue'
import { checkPagePermission } from '@/utils/checkRoles.js'

export default {
  components: {
    EXCMTagForm
  },

  data () {
    return {
      item: {}
    }
  },

  beforeCreate () {
    checkPagePermission('configuration', 'EXCMTagUpdate')
  },

  computed: {
    ...mapGetters({
      isLoading: 'excmtag/update/isLoading',
      error: 'excmtag/update/error',
      deleteError: 'excmtag/del/error',
      deleteLoading: 'excmtag/del/isLoading',
      created: 'excmtag/create/created',
      deleted: 'excmtag/del/deleted',
      retrieved: 'excmtag/update/retrieved',
      updated: 'excmtag/update/updated',
      violations: 'excmtag/update/violations'
    })
  },

  watch: {
    // eslint-disable-next-line object-shorthand,func-names
    deleted: function (deleted) {
      if (!deleted) {
        return
      }

      this.$router.push({ name: 'EXCMTagList' })
    }
  },

  beforeDestroy () {
    this.reset()
  },

  created () {
    this.retrieve(decodeURIComponent(this.$route.params.id))
  },

  methods: {
    ...mapActions({
      createReset: 'excmtag/create/reset',
      deleteItem: 'excmtag/del/del',
      delReset: 'excmtag/del/reset',
      retrieve: 'excmtag/update/retrieve',
      updateReset: 'excmtag/update/reset',
      update: 'excmtag/update/update',
      updateRetrieved: 'excmtag/update/updateRetrieved'
    }),

    del () {
      if (window.confirm('Are you sure you want to delete this excmtag ?')) {
        this.deleteItem(this.retrieved)
      }
    },

    reset () {
      this.updateReset()
      this.delReset()
      this.createReset()
    },

    onSendForm () {
      this.update()
    },

    updateField (field, value) {
      this.updateRetrieved({ [field]: value })
    }
  }
}
</script>
